export default __webpack_public_path__ + "static/media/molecular-biology-solution-2.e1129518.png";